/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-04-10 16:10:31
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-05-05 15:57:16
 * @FilePath: /tntd/packages/tntd/src/descriptions/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import Descriptions from 'antd/lib/descriptions'

import 'antd/lib/descriptions/style'
import { Descriptions } from './descriptions'

import './descriptions.less'
export * from './descriptions'

export default Descriptions
